import React, { Fragment, useState } from 'react';
import axios from 'axios';
import Button from 'components/buttons/Button';
import toast from 'react-hot-toast';
import LoadingSpinner from 'components/LoadingSpinner';
import dynamic from 'next/dynamic';
import { Transition } from '@headlessui/react';

const Lottie = dynamic(() => import('react-lottie-player'), {
    ssr: false
});

function NewsletterCard() {
    const [email, setEmail] = useState('');
    const [state, setState] = useState('idle');
    const [confettiAnimationData, setConfettiAnimationData] = useState(null);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setState('loading');

        try {
            await axios.post('/api/newsletter-signup', { email });
            // Set of confetti animation!
            import('components/cards/confetti.json').then((data) => {
                setConfettiAnimationData(data);
                setState('success');
                setEmail('');
            });
        } catch (e) {
            setState('idle');
            if (e.response.data.message.toLowerCase().includes('exists')) {
                toast.error('Ta e-poštni naslov je že na seznamu prejemnikov.');
            } else {
                toast.error('Pri prijavi je šlo nekaj narobe. Preverti e-poštni naslov in poskusite znova.');
            }
        }
    };

    return (
        <div className="rounded-xl shadow-md border-2 border-brand bg-brand-dull p-4 relative max-w-xs mx-auto">
            {state === 'success' && (
                <>
                    {confettiAnimationData && (
                        <Lottie
                            animationData={confettiAnimationData}
                            play
                            loop={false}
                            style={{ width: 600, height: 600 }}
                            className="absolute -left-[130px] -top-[150px]"
                        />
                    )}
                </>
            )}

            <Transition
                show={state === 'success'}
                as={Fragment}
                enter="transition transform ease-out duration-800 delay-700"
                enterFrom="transform opacity-0 scale-0"
                enterTo="transform opacity-1 scale-1"
            >
                <div className="content text-center absolute inset-2 flex justify-center items-center flex-col gap-4">
                    <h3 className="uppercase font-serif text-brand text-2xl leading-tight">Prijava je uspela!</h3>
                    <p>TOP ideje za izlet bodo kmalu v tvojem nabiralniku.</p>
                    <Button type="submit" variant="contained" color="secondary" onClick={() => setState('idle')}>
                        Ponovi prijavo
                    </Button>
                </div>
            </Transition>

            <div className={`${state === 'success' ? 'invisible' : ''}`}>
                <div className={`content pr-28 2xl:pr-32 relative`}>
                    <h3 className="uppercase font-serif text-brand text-2xl leading-tight">
                        Top ideje za izlet v tvoj nabiralnik
                    </h3>
                    <p className="mt-4 relative z-10 leading-tight">
                        Enkrat na mesec pošiljamo najboljše ideje za izlet po Sloveniji.
                    </p>
                    <img
                        src="/images/newsletter.svg"
                        alt="Bunch of letters flying out of megaphone"
                        className="absolute w-28 xl:w-28 2xl:w-32 bottom-3 right-0"
                    />
                </div>
                <form onSubmit={handleSubmit} className="mt-4">
                    <div className="input-wrap relative">
                        <input
                            type="email"
                            required
                            className="w-full rounded-full border border-gray-700 py-2 pl-4 pr-28 md:text-sm h-10 focus:outline-none focus:ring-brand focus:ring-2"
                            placeholder="Vpiši svoj email ..."
                            onChange={(e) => setEmail(e.target.value)}
                            value={email}
                        />
                        <Button
                            type="submit"
                            variant="contained"
                            color="secondary"
                            styles="absolute right-0 w-28 top-0 text-sm h-10"
                            disabled={state === 'loading'}
                        >
                            {state === 'loading' ? (
                                <LoadingSpinner width={'1.5em'} height={'1.5em'} />
                            ) : (
                                <span>Prijavi se</span>
                            )}
                        </Button>
                    </div>
                </form>
                <p className="text-[10px] text-gray-400 mt-3 text-center leading-tight">
                    S prijavo se strinjam, da podjetje HUDDA d.o.o. shrani moj e-poštni naslov in ga uporabi za
                    pošiljanje idej za izlet in drugih novosti na portalu Kam za vikend.
                </p>
            </div>
        </div>
    );
}

NewsletterCard.propTypes = {};

export default NewsletterCard;
